import React, { Component } from "react";

export default class StoreTemplate extends Component {
  constructor(props, context) {
    super(props);
    this.storeContext = context;
  }

  excludePropreties = new Set(["constructor", "render", "storeData"]);

  get storeData() {
    return {
      store: this.state,
      actions: Object.getOwnPropertyNames(Object.getPrototypeOf(this))
        .filter((item) => !this.excludePropreties.has(item))
        .reduce((prev, action) => {
          prev[action] = this[action].bind(this);
          return prev;
        }, {}),
    };
  }

  render() {
    return (
      <this.storeContext.Provider value={this.storeData}>
        {this.props.children}
      </this.storeContext.Provider>
    );
  }
}
